import { Redirect } from 'react-router-dom';

const HomeRedirect = () => {
  // Check specifically for logout flag (not just missing token)
  const justLoggedOut = sessionStorage.getItem('just_logged_out');

  // Debug info
  const authToken = localStorage.getItem('kt_token');
  const persistAuth = localStorage.getItem('persist:ens-auth');

  console.log('HomeRedirect - Debug info:', {
    justLoggedOut,
    authToken: !!authToken,
    persistAuth: !!persistAuth,
    pathname: window.location.pathname
  });

  // If user just logged out, always redirect to login
  if (justLoggedOut) {
    sessionStorage.removeItem('just_logged_out');
    console.log('HomeRedirect - Redirecting to login after logout');
    return <Redirect to="/auth/login" />;
  }

  console.log('HomeRedirect - Redirecting to login (default)');
  return <Redirect to="/auth/login" />;
};

export default HomeRedirect;
